const config = {
  name: 'dungeon-pad-pancake',
  tempPageId: '670bebdc3e270a47aab7c8f0',
  gmPassword: 'everything'
};

module.exports = config;
